<script setup lang="ts">
import { computed } from "vue";
import { useFormattedPercent } from "~/composables/useFormattedPercent";

export interface FormattedPercentProps {
  locale?: string;
  precision?: number;
  showPositivePrefix?: boolean;
  value: number | string;
}

const props = defineProps<FormattedPercentProps>();

const formattedValue = computed(() => {
  const { formattedValue } = useFormattedPercent(props.value, props);
  return formattedValue;
});
</script>

<template>{{ formattedValue }}</template>
